import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

const createClasses = (obj, property, nameAddition = "") =>
  Object.keys(obj).reduce(
    (a, c) => ({ ...a, [`${nameAddition}${c}`]: { [property]: obj[c] } }),
    {}
  );

const InputComponent = ({
  className,
  classes,
  color,
  font_weight,
  size,
  textarea,
  ...props
}) => textarea ? (
  <textarea
    className={`
        ${classes[`color_${color}`]}${" "}
        ${classes[`fontWeight_${font_weight}`]}
         ${classes[`fontSize_${size}`]}
        ${className}
      `}
    {...props}
  />
) : (
      <input
        className={`
            ${classes[`color_${color}`]}${" "}
            ${classes[`fontWeight_${font_weight}`]}
            ${classes[`fontSize_${size}`]}
            ${className}
          `}
        {...props}
      />
    )

InputComponent.propTypes = {
  color: PropTypes.oneOf([
    "white",
    "black",
    "darkBlack",
    "deepGrey",
    "mediumGrey",
    "hylyBlue",
    "red"
  ]),
  size: PropTypes.oneOf([
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
  ]),
  font_weight: function (props, propName, componentName) {
    if (
      !/\d+/.test(props[propName]) ||
      +props[propName] > 600 ||
      +props[propName] < 200
    ) {
      return new Error(
        "Invalid prop `" +
        propName +
        "` supplied to" +
        " `" +
        componentName +
        "`. Expected a number in range between 200 - 600."
      );
    }
  }
};

InputComponent.defaultProps = {
  color: "darkBlack",
  font_weight: "400"
};

export default withStyles(() => ({
  ...createClasses(
    {
      white: "#fff",
      black: "#000",
      darkBlack: "#333",
      deepGrey: "#4F4F4F",
      mediumGrey: "#CCC",
      hylyBlue: "#26bbed",
      red: "#FF5151"
    },
    "color",
    "color_"
  ),
  ...createClasses(
    {
      "200": 200,
      "300": 300,
      "400": 400,
      "500": 500,
      "600": 600
    },
    "fontWeight",
    "fontWeight_"
  ),
  ...createClasses(
    {
      "xs": 10,
      "sm": 12,
      "md": 14,
      "lg": 16,
      "xl": 18
    },
    "fontSize",
    "fontSize_"
  )
}))(InputComponent);
